import React from 'react'
// import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom';

import { MainLayout, SideBarLayout } from '../../layouts';
import { SideBarPublications, Articles, Thesis } from './components';
import { baseUrl } from '../../config/baseUrl';

const Publications = props => {
  const sideBar = <SideBarPublications />;
  return (
    <MainLayout>
      <SideBarLayout sideBar={sideBar}>
        <Switch>
          <Route path={`${baseUrl}publications`} exact component={Articles} />
          <Route path={`${baseUrl}publications/thesis`} exact component={Thesis} />
        </Switch>
      </SideBarLayout>
    </MainLayout>
  )
}

Publications.propTypes = {

}

export default Publications
